import { render, staticRenderFns } from "./OrderCol.vue?vue&type=template&id=7a695a11&"
import script from "./OrderCol.vue?vue&type=script&lang=js&"
export * from "./OrderCol.vue?vue&type=script&lang=js&"
import style0 from "./OrderCol.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports